import { render } from "./TheEmailBtn.vue?vue&type=template&id=e2fbfbb2&scoped=true"
import script from "./TheEmailBtn.vue?vue&type=script&lang=js"
export * from "./TheEmailBtn.vue?vue&type=script&lang=js"

import "./TheEmailBtn.vue?vue&type=style&index=0&id=e2fbfbb2&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2fbfbb2"]])

export default __exports__